import axios from "axios";

const instance = axios.create({
  baseURL: "https://api.coincap.io/v2/",
});

const pageSize = 15;
const TOPCurrencies = 3;

export const coinAPI = {
  getCurrencies(currentPage) {
    return instance.get(
      `assets?offset=${currentPage * pageSize}&limit=${pageSize}`
    );
  },
  getCurrency(id) {
    return instance.get(`assets/${id}`);
  },
  getTopCurrencies() {
    return instance.get(`assets?limit=${TOPCurrencies}`);
  },
  getCurrencyHistory(id) {
    return instance.get(`assets/${id}/history?interval=d1`);
  },
};
